// extracted by mini-css-extract-plugin
export default {"container":"bw9_7a","viewer":"ZSecoR","truncated":"KTxDM7","expandTransition":"qYJJ6p","shrinkTransition":"JoHhPy","showMore":"JwJKE_"};